import { render } from "./AssTeacherMaster.vue?vue&type=template&id=fe72bd8a&scoped=true"
import script from "./AssTeacherMaster.vue?vue&type=script&lang=js"
export * from "./AssTeacherMaster.vue?vue&type=script&lang=js"

import "./AssTeacherMaster.vue?vue&type=style&index=0&id=fe72bd8a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe72bd8a"]])

export default __exports__